const useTopScroll = () => {
  window.scrollTo(0, 0);
};

export default useTopScroll;
